import { Helmet } from 'react-helmet-async';

interface Props {
  title?: string | null,
  ogTitle?: string | null,
}

export const PageMetaTitle: React.FC<Props> = ({
  title,
  ogTitle,
}) => {
  if (title) {
    return (
      <Helmet>
        <title>{title}</title>

        <meta property="og:title" content={ogTitle || title} />
        <meta name="twitter:title" content={ogTitle || title} />
      </Helmet>
    );
  }

  return null;
};
